import React from 'react';

const phone = "919766624663";

const services = [
  {
    title: "Paint Protection Film (PPF)",
    desc: "Ultimate protection against scratches, stone chips, and UV damage.",
    image: "./PPF.jpg", // ← paste your image URL here, e.g. "/images/ppf.jpg"
  },
  {
    title: "Ceramic Coating",
    desc: "Long-lasting shine with hydrophobic protection.",
    image: "./Detailing.jpg",
  },
  {
    title: "Car Detailing",
    desc: "Deep cleaning, polishing, and interior restoration.",
    image: "./ExteriorPolish.jpg",
  },
  {
    title: "Interior Cleaning",
    desc: "Premium interior detailing for a fresh, new feel.",
    image: "./Interior.jpg",
  },
  {
    title: "Exterior Polishing",
    desc: "Restore paint gloss and remove swirl marks.",
    image: "./Polishing.jpg",
  },
];

/* ── Placeholder SVG shown when no image is provided ── */
function ImagePlaceholder({ title }: { title: string }) {
  return (
    <div style={{
      width: '100%', height: '180px',
      background: 'linear-gradient(135deg, #1a1a1a 0%, #141414 100%)',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: '10px',
      borderBottom: '1px solid #222',
    }}>
      <svg width="44" height="44" viewBox="0 0 44 44" fill="none">
        <rect x="4" y="10" width="36" height="26" rx="4" stroke="#333" strokeWidth="1.5"/>
        <circle cx="15" cy="20" r="4" stroke="#444" strokeWidth="1.5"/>
        <path d="M4 28l9-7 7 6 5-4 11 9" stroke="#333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M28 10v-4M22 10V7M34 10V8" stroke="#2a2a2a" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
      <span style={{ fontSize: '11px', color: '#333', letterSpacing: '0.08em', textTransform: 'uppercase' }}>
        Add Image
      </span>
    </div>
  );
}

export default function GlossGarage() {
  const openWhatsApp = () => {
    const message = "Hi, I'm interested in Gloss Garage services. Please share details.";
    window.open(
      `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <div style={{ background: '#080808', color: '#fff', minHeight: '100vh' }}>

      {/* ── HERO ── */}
      <section style={hero}>
        <div style={overlay} />
        <div style={heroContent}>
          <h1 style={title}>
            Gloss <span style={{ color: '#FFD700' }}>Garage</span>
          </h1>
          <p style={subtitle}>Premium Car Care & Protection Services</p>
          <div style={{ display: 'flex', gap: 12, marginTop: 20, flexWrap: 'wrap', justifyContent: 'center' }}>
  <button
    style={{
      ...primaryBtn,
      display: 'flex', alignItems: 'center', gap: '10px',
      padding: '13px 22px', borderRadius: '12px',
    }}
    onClick={openWhatsApp}
    onMouseEnter={e => {
      (e.currentTarget as HTMLButtonElement).style.transform = 'translateY(-2px)';
      (e.currentTarget as HTMLButtonElement).style.boxShadow = '0 8px 24px rgba(255,215,0,0.35)';
    }}
    onMouseLeave={e => {
      (e.currentTarget as HTMLButtonElement).style.transform = 'translateY(0)';
      (e.currentTarget as HTMLButtonElement).style.boxShadow = 'none';
    }}
  >
    <div style={{
      width: '30px', height: '30px', borderRadius: '8px',
      background: 'rgba(0,0,0,0.12)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
    }}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    </div>
    Book on WhatsApp
  </button>

  <a
    href={`tel:+${phone}`}
    style={{
      ...secondaryBtn,
      display: 'flex', alignItems: 'center', gap: '10px',
      padding: '13px 22px', borderRadius: '12px',
      border: '1px solid rgba(255,255,255,0.1)',
      transition: 'transform 0.2s, border-color 0.2s, background 0.2s',
    }}
    onMouseEnter={e => {
      (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(-2px)';
      (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(255,255,255,0.25)';
      (e.currentTarget as HTMLAnchorElement).style.background = '#222';
    }}
    onMouseLeave={e => {
      (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(0)';
      (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(255,255,255,0.1)';
      (e.currentTarget as HTMLAnchorElement).style.background = '#1a1a1a';
    }}
  >
    <div style={{
      width: '30px', height: '30px', borderRadius: '8px',
      background: 'rgba(255,255,255,0.06)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
    }}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1V20a1 1 0 01-1 1C9.61 21 3 14.39 3 6a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.45.57 3.57a1 1 0 01-.25 1.02l-2.2 2.2z"
          stroke="#ccc" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
    Call Now
  </a>
</div>
        </div>
      </section>

      {/* ── SERVICES ── */}
      <section style={section}>
        <h2 style={sectionTitle}>Our Services</h2>
        <div style={grid}>
          {services.map((s, i) => (
            <div key={i} style={card}>
              {/* Image area */}
              {s.image ? (
                <div style={{ width: '100%', height: '180px', overflow: 'hidden', borderBottom: '1px solid #222' }}>
                  <img
                    src={s.image}
                    alt={s.title}
                    style={{
                      width: '100%', height: '100%', objectFit: 'cover',
                      transition: 'transform 0.4s ease',
                      display: 'block',
                    }}
                    onMouseEnter={e => (e.currentTarget.style.transform = 'scale(1.05)')}
                    onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
                  />
                </div>
              ) : (
                <ImagePlaceholder title={s.title} />
              )}

              {/* Text content */}
              <div style={{ padding: '16px 18px 18px' }}>
                {/* Gold accent line */}
                <div style={{
                  width: '28px', height: '2px',
                  background: '#FFD700', borderRadius: '2px',
                  marginBottom: '10px',
                }} />
                <h3 style={cardTitle}>{s.title}</h3>
                <p style={cardDesc}>{s.desc}</p>
                <button
                  onClick={openWhatsApp}
                  style={{
                    marginTop: '14px',
                    background: 'transparent',
                    border: '1px solid rgba(255,215,0,0.3)',
                    color: '#FFD700', borderRadius: '8px',
                    padding: '8px 14px', fontSize: '12px',
                    fontWeight: 600, cursor: 'pointer',
                    transition: 'background 0.2s, border-color 0.2s',
                    letterSpacing: '0.02em',
                  }}
                  onMouseEnter={e => {
                    (e.currentTarget as HTMLButtonElement).style.background = 'rgba(255,215,0,0.08)';
                    (e.currentTarget as HTMLButtonElement).style.borderColor = '#FFD700';
                  }}
                  onMouseLeave={e => {
                    (e.currentTarget as HTMLButtonElement).style.background = 'transparent';
                    (e.currentTarget as HTMLButtonElement).style.borderColor = 'rgba(255,215,0,0.3)';
                  }}
                >
                  Enquire →
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── WHY CHOOSE US ── */}
      <section style={sectionAlt}>
        <h2 style={sectionTitle}>Why Choose Gloss Garage?</h2>
        <div style={grid}>
          {[
            "Premium Quality Materials",
            "Experienced Professionals",
            "Advanced Equipment",
            "Affordable Pricing",
            "Customer Satisfaction Guaranteed",
          ].map((item, i) => (
            <div key={i} style={benefit}>
              ✔ {item}
            </div>
          ))}
        </div>
      </section>

      {/* ── CTA ── */}
      <section style={cta}>
        <h2 style={{ fontSize: 22, marginBottom: 10 }}>
          Give Your Car the Shine it Deserves
        </h2>
        <p style={{ color: '#aaa', marginBottom: 20 }}>
          Book your appointment today and experience premium detailing.
        </p>
        <button style={primaryBtn} onClick={openWhatsApp}>
          💬 Book Now on WhatsApp
        </button>
      </section>
    </div>
  );
}

/* ── STYLES ── */

const hero: React.CSSProperties = {
  position: 'relative', height: '60vh',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  backgroundImage: "url('https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?w=1600&q=80')",
  backgroundSize: 'cover', backgroundPosition: 'center',
};
const overlay: React.CSSProperties = { position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.7)' };
const heroContent: React.CSSProperties = { position: 'relative', textAlign: 'center', zIndex: 2 };
const title: React.CSSProperties = { fontSize: '40px', fontWeight: 800 };
const subtitle: React.CSSProperties = { marginTop: '10px', color: '#ccc' };

const section: React.CSSProperties = { padding: '50px 20px', maxWidth: '1200px', margin: '0 auto' };
const sectionAlt: React.CSSProperties = { padding: '50px 20px', background: '#111' };
const sectionTitle: React.CSSProperties = { fontSize: '22px', marginBottom: '25px', textAlign: 'center' };

const grid: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
  gap: '16px',
};

const card: React.CSSProperties = {
  background: '#111', borderRadius: '14px',
  border: '1px solid #1e1e1e', overflow: 'hidden',
  transition: 'border-color 0.2s, transform 0.2s',
};

const cardTitle: React.CSSProperties = { fontSize: '16px', fontWeight: 700, marginBottom: '8px', color: '#fff' };
const cardDesc: React.CSSProperties = { fontSize: '13px', color: '#aaa', lineHeight: 1.6 };

const benefit: React.CSSProperties = {
  background: '#111', padding: '14px', borderRadius: '8px',
  border: '1px solid #1e1e1e', fontSize: '13px',
};

const cta: React.CSSProperties = { padding: '50px 20px', textAlign: 'center' };

const primaryBtn: React.CSSProperties = {
  background: '#FFD700', color: '#000', border: 'none',
  padding: '12px 20px', borderRadius: '8px', fontWeight: 600, cursor: 'pointer',
};

const secondaryBtn: React.CSSProperties = {
  background: '#1a1a1a', color: '#ccc',
  padding: '12px 20px', borderRadius: '8px', textDecoration: 'none',
};